import React from 'react'
import tw from 'twin.macro';
import styled from "styled-components";
import { ReactComponent as DollarIcon } from "feather-icons/dist/icons/dollar-sign.svg";
export const ThreeColumnContainer = styled.div`
  ${tw`mt-1 flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
`;
const Column = styled.div`
  ${tw`lg:w-1/3 max-w-xs`}
`;

const Card = styled.div`
  ${tw`flex md:flex-row gap-2 flex-col items-center sm:items-start text-center sm:text-left h-full w-80  px-2 py-5`}
  .imageContainer {
    ${tw` items-start mt-3 rounded-full p-3 text-primary-500 border border-gray-500 flex-shrink-0`}
    .image {
      ${tw`w-6 h-6 `}
      
    }
  }

  .textContainer {
    ${tw`mt-4 ml-2`}
  }

  .title {
    ${tw`mt-4 text-xl font-bold text-xl  h-5`}
  }

  .description {
    ${tw`mt-4 text-justify md:text-justify  sm:text-justify text-gray-600 leading-relaxed`}
    font-size: 16px;
  }
`;
  
const DetailsCard = ({index,title,description,imageSrc}) => {

  return (
    <Column>
 <Card>
              <span className="imageContainer">
             {imageSrc}
              </span>
              <span className="textContainer">
                <span className="title">{title }</span>
                <p className="description">
                  {description }
                </p>
              </span>
            </Card>

    </Column>
  );
}




export default DetailsCard